import { Field, useFormikContext } from 'formik';
import { ClipboardEvent } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

import { useViaCepSearch } from '@/resources/hooks/useAddressUtils';
import { maskZipcode } from '@/services/global';

import { ControlLabel } from '../../Form/ControlLabel';
import { InputGroup } from '../../Form/Inputgroup';
import { LabelWrapper } from '../../Form/LabelWrapper';
import { RowGroup } from '../../Form/RowGroup';
import { IAddressModalStep, IAddressValues } from './types';

export function AddAddressForm({
  setModalStep,
}: {
  setModalStep: (step: IAddressModalStep) => void;
}) {
  const { values, setFieldValue } = useFormikContext<IAddressValues>();

  const handlePasteZipcode = async (e: ClipboardEvent<HTMLInputElement>) => {
    const value = e.clipboardData?.getData('text/plain');
    const input = e.target as HTMLInputElement;
    input.value = maskZipcode(value);
    const data = await useViaCepSearch(value);
    if (!data) return;
    setFieldValue('street', data.street || '');
    setFieldValue('city', data.city || '');
    setFieldValue('state', data.state || '');
    setFieldValue('neighborhood', data.neighborhood || '');
    setFieldValue('zipcode', data.zipcode || '');
  };

  const handleChangeZipcode = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = maskZipcode(e.target.value);
    setFieldValue('zipcode', maskZipcode(e.target.value));
    if (e.target.value.length === 9) {
      const data = await useViaCepSearch(e.target.value);

      if (!data) return;
      setFieldValue('street', data.street || '');
      setFieldValue('city', data.city || '');
      setFieldValue('state', data.state || '');
      setFieldValue('neighborhood', data.neighborhood || '');
      setFieldValue('zipcode', data.zipcode || '');
    }
  };

  return (
    <div className="p-2">
      <RowGroup>
        <InputGroup>
          <div className="d-flex justify-content-between align-items-center">
            <ControlLabel required={true}>CEP:</ControlLabel>
            <Form.Label className="mb-0">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.buscacep.correios.com.br"
              >
                consultar
              </a>
            </Form.Label>
          </div>
          <Field
            type="text"
            name="zipcode"
            placeholder="00000-000"
            data-type="address"
            required
            className="form-control data-input mb-lg-0 mb-2"
            onChange={handleChangeZipcode}
            onPaste={handlePasteZipcode}
          />
        </InputGroup>
        <InputGroup>
          <LabelWrapper>
            <ControlLabel required>Rua:</ControlLabel>
            <Form.Label className="mb-0">
              <a
                target="_blank"
                href={`https://www.google.com/maps/search/?api=1&query=${values?.street}`}
                rel="noopener noreferrer"
              >
                Ver no google
              </a>
            </Form.Label>
          </LabelWrapper>

          <Field
            type="text"
            name="street"
            required
            data-type="address"
            placeholder="Escreva..."
            className="form-control data-input mb-lg-0 mb-2"
          />
        </InputGroup>
        <InputGroup>
          <LabelWrapper>
            <ControlLabel required>Número:</ControlLabel>
          </LabelWrapper>

          <Field
            type="number"
            name="number"
            required
            data-type="address"
            placeholder="Escreva..."
            className="form-control data-input mb-lg-0 mb-2"
          />
        </InputGroup>
      </RowGroup>

      <RowGroup>
        <InputGroup>
          <LabelWrapper>
            <ControlLabel required>Bairro:</ControlLabel>
          </LabelWrapper>

          <Field
            type="text"
            name="neighborhood"
            placeholder="Escreva..."
            required
            data-type="address"
            className="form-control data-input mb-lg-0 mb-2"
          />
        </InputGroup>
        <InputGroup>
          <LabelWrapper>
            <ControlLabel required={true}>Cidade:</ControlLabel>
          </LabelWrapper>
          <Field
            type="text"
            placeholder="Escreva..."
            name="city"
            data-type="address"
            className="form-control data-input mb-lg-0 mb-2"
          />
        </InputGroup>
        <InputGroup>
          <LabelWrapper>
            <ControlLabel required={true}>Estado: </ControlLabel>
          </LabelWrapper>
          <Field
            type="text"
            name="state"
            data-type="address"
            required
            placeholder="Escreva..."
            className="form-control data-input mb-lg-0 mb-2"
          />
        </InputGroup>
      </RowGroup>
      <RowGroup>
        <InputGroup className="w-50">
          <LabelWrapper>
            <ControlLabel>Complemento:</ControlLabel>
          </LabelWrapper>
          <Field
            type="text"
            name="complement"
            data-type="address"
            placeholder="Escreva..."
            className="form-control data-input mb-lg-0 mb-2 "
          />
        </InputGroup>
        <InputGroup className="w-50">
          <LabelWrapper>
            <ControlLabel>Referência:</ControlLabel>
          </LabelWrapper>
          <Field
            type="text"
            name="reference"
            placeholder="Escreva..."
            data-type="address"
            className="form-control data-input mb-lg-0 mb-2"
          />
        </InputGroup>
      </RowGroup>
      <Modal.Footer className="d-flex justify-content-end py-0 pr-0">
        <Button
          variant="secondary"
          size="sm"
          className="mt-2"
          onClick={() => {
            setModalStep('address');
          }}
        >
          Cancelar
        </Button>
        <Button variant="success" type="submit" size="sm" className="mt-2">
          Salvar
        </Button>
      </Modal.Footer>
    </div>
  );
}
